import config from '../config/config';

let version = config.appVersion;

export const AppVersionMiddleware = {
  get version() {
    return version;
  },

  setVersion(value: string) {
    version = value;
  },

  getHeader(): Record<string, string> {
    return { AppVersion: version };
  },
};
